module.exports = __webpack_public_path__ + "img/geoseis.489a97fe.jpg";